import EAButton from "components/common/EAButton";
import EAIcon from "components/common/EAIcon";
import i18next from "i18next";
import { useContext, useState } from "react";
import { ERROR } from 'services/common/Constants';
import { stopEvaluation } from "services/edge/SecurityRatingService";
import { Context } from "states/Store";
import StoppingConfirmationDialog from "components/common/StoppingConfirmationDialog";
import { SecurityRatingConfigStatus, SecurityRatingContext } from "services/common/SecurityRatingUtils";


const SecurityRatingStopEvaluationButton = ({ disabled = true, onRiskChange = () => { } }) => {
  const [state, dispatch] = useContext(Context);

  const { setConfig } = useContext(SecurityRatingContext);

  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const stopEvaluationHandler = async () => {
    try {
      await stopEvaluation(
        state.account.id,
        state.thirdparty.thirdpartyId
      );
      onRiskChange();
      setConfig(e => ({
        ...e,
        status: SecurityRatingConfigStatus.INACTIVE
      }))
    } catch (error) {
      dispatch({
        type: 'ALERT',
        alert: {
          type: ERROR,
          msg: error?.message?.messages?.error?.[0]?.code || 'INTERNAL_ERROR',
        },
      });
    }
  };

  const openConfirmDialog = () => {
    setConfirmDialogOpen(true);
  }

  return (
    <>
      <EAButton
        size="small"
        onClick={openConfirmDialog}
        colorVariant="errorLight"
        customStyle={{ boxShadow: "none", minHeight: "30px" }}
        disabled={disabled}
        content={
          <>
            <EAIcon icon="stop_scoring" />
            <span>{i18next.t('securityRating.stopEvaluation')}</span>
          </>
        }
      />

      <StoppingConfirmationDialog
        title={i18next.t("securityRating.stopEvaluationTitle")}
        description={i18next.t("securityRating.stopEvaluationDescription")}
        isOpen={isConfirmDialogOpen}
        onValidate={stopEvaluationHandler}
        onClose={() => setConfirmDialogOpen(false)}
      />
    </>
  )
};

export default SecurityRatingStopEvaluationButton;